import React from "react";
import { Link } from "react-router-dom";
export default function ModelListItem(props) {
  const clickHandler = (e) => {
    if (props.onModelPick) {
      e.preventDefault();
    }
    if (props.onModelCheck) {
      e.preventDefault();
      props.onModelCheck(props);
    }
  };

  const dblClickHandler = (e) => {
    if (props.onModelPick) {
      e.preventDefault();
      props.onModelPick(props);
    }
  };

  return (
    <>
      <Link
        onClick={(e) => clickHandler(e)}
        onDoubleClick={(e) => dblClickHandler(e)}
        to={`/model/${props.categoryId}/${props.id}/`}
      >
        <div
          className={`row py-4 px-2 border-bottom text-dark bg-hover-light align-items-center ${
            props.highlightItem === String(props.id) ? "bg-light" : ""
          }`}
        >
          {props.onModelCheck && (
            <div className="btn btn-sm btn-icon">
              <i
                className={`fa ${
                  props.checkedModels.includes(props.id)
                    ? "fa-check-square-o text-primary"
                    : "fa-square-o"
                }`}
              ></i>
            </div>
          )}

          <div className="col  m-lg-0 my-3">
            <div>{props.name}</div>
            <div className="small">
              {props.subcode && (
                <span className="text-dark-50 mr-2">{props.subcode}</span>
              )}
              {props.vendorname && (
                <span className="text-dark-75">{props.vendorname}</span>
              )}
            </div>

            <div className="text-muted small">{props.description}</div>
          </div>
        </div>
      </Link>
    </>
  );
}
